import React, { useEffect, useState } from 'react';
import { ROOMS } from '../rooms';
import { useCityStore } from '../city/cityStore';
import { stateAt } from '../city/cityMotion';
import { serverNow } from '../services/worldSocket';
import RoomPerson from './RoomPerson';

// RoomHost — the owner of a room, there when they are actually there (2026-10-31).
//
// Khari: "As of now, there is a duplicate resident of him there, but we should
// replace that with a live presence when he is actually there."
//
// Whose room it is comes from the server (API city_rooms → snapshot `rooms`).
// Whether they are in is THEIR OWN TIMELINE, the one the whole city shares: a
// stay of theirs inside this room (`r` = this room, `ho` = in at their own room,
// API CityLifeService.ensureRoomHosts — only ever after their yes). Then they
// stand at the booth, the same body and the same way a set's performer does
// (VenueStage Performer); when the stay ends they are gone, back out into the
// city, where the street draws them again. Never a standing copy: the static
// resident of the owner placed in the room is not drawn (InteriorResidents).
//
// A tap is the street's: they stop for you and the chat opens with THEM,
// knowing where they are — not a copy that answers. Their label says whether
// they are free and a refused tap says why (RoomPerson); until 2026-11-01 every
// tap here was refused (their stay is filed as a story stay) and said nothing.

export default function RoomHost({ roomId, k = 1 }) {
  const room = ROOMS[roomId];
  const mark = room?.booth || null;
  const hostId = useCityStore((s) => s.snap?.rooms?.[roomId]?.host ?? null);
  const hostName = useCityStore((s) => s.snap?.rooms?.[roomId]?.name || '');
  const [inside, setInside] = useState(false);

  // From the shared timeline, once a second: are they in this room right now?
  useEffect(() => {
    if (hostId == null || !mark) { setInside(false); return undefined; }
    const check = () => {
      const cs = useCityStore.getState();
      const r = cs.byId?.[hostId];
      const st = r ? stateAt(r, serverNow(), cs.convs) : null;
      setInside(!!st && st.inside === roomId && !!st.seg?.ho);
    };
    check();
    const t = setInterval(check, 1000);
    return () => clearInterval(t);
  }, [hostId, roomId, mark]);

  if (!inside || !mark) return null;
  const light = (room?.light ?? 1) * (room?.model ? 0.45 : 1);
  return <RoomPerson key={hostId} avatarId={hostId} name={hostName} mark={mark} k={k} light={light} />;
}
